import React, {useEffect} from "react";
import {observer} from "mobx-react"
import {useModelContext} from "@app/contexts/model";
import {FormLogin} from '../FormLogin';
import {ContentApp} from '../ContentApp';
import {AppHeader} from "../AppHeader";
import { ThemeProvider } from '@mui/material/styles';
import './Root.scss'
import {useStorageContext} from "@app/contexts/storage";
import {MAIN_PAGE} from "@app/enums";
import {createTheme} from "@app/theme/materialUi.config";

export const Root = observer(() => {

    const {authorizationModel} = useModelContext();
    const {globalStorage} = useStorageContext();

    const theme = createTheme();

    useEffect(() => {
        if (globalStorage.openModule === MAIN_PAGE.LOGOUT && authorizationModel.user.get() !== null) {
            globalStorage.LogOutIconClicked = true
            authorizationModel.logout();
            globalStorage.openModule = MAIN_PAGE.LOGOUT;
            globalStorage.functionsButton.clear();

        } else authorizationModel.relogin().then(value => {
            if (value) {
                globalStorage.LogOutIconClicked = false
                globalStorage.openModule = MAIN_PAGE.TRANSLATE;
            }
        }, (err) =>
            console.error(err));

    });

    return  <ThemeProvider theme={theme}>

        <AppHeader/>
        {globalStorage.openModule === MAIN_PAGE.LOGOUT ? <FormLogin/> : <ContentApp/>}

    </ThemeProvider>
});



